import { Root, HoverCardProps } from '@radix-ui/react-hover-card';

export const HoverCard: React.FC<React.PropsWithChildren<HoverCardProps>> = ({
  children,
  ...rest
}) => {
  return <Root {...rest}>{children}</Root>;
};
